interface GetDateSectionsProps {
  endDay: number;
  endMonth: string;
  isSameMonth: boolean;
  isSingleDay: boolean;
  startDay: number;
  startMonth: string;
}

const getDateSections = ({
  endDay,
  endMonth,
  isSameMonth,
  isSingleDay,
  startDay,
  startMonth,
}: GetDateSectionsProps) => {
  if (isSingleDay) {
    return [{ day: startDay, month: startMonth }];
  }

  if (isSameMonth) {
    return [{ day: `${startDay}-${endDay}`, month: startMonth }];
  }

  return [
    { day: `${startDay}-`, month: startMonth },
    { day: endDay, month: endMonth },
  ];
};

const formatMonth = (date: Date, language?: string) =>
  date
    .toLocaleDateString(language, {
      month: 'short',
    })
    .replace('.', '')
    .toUpperCase();

export const getVolunteerEventInfoData = ({
  endDate,
  language,
  startDate,
}: {
  endDate: Date;
  language?: string;
  startDate: Date;
}) => {
  const startMonth = formatMonth(startDate, language);
  const endMonth = formatMonth(endDate, language);
  const startDay = startDate.getDate();
  const endDay = endDate.getDate();
  const isSameMonth =
    startDate.getFullYear() === endDate.getFullYear() &&
    startDate.getMonth() === endDate.getMonth();
  const isSingleDay = isSameMonth && startDate.getDate() === endDate.getDate();

  return {
    dateSections: getDateSections({
      endDay,
      endMonth,
      isSameMonth,
      isSingleDay,
      startDay,
      startMonth,
    }),
    dateTime: isSingleDay
      ? startDate.toISOString()
      : `${startDate.toISOString()}/${endDate.toISOString()}`,
    isSingleDay,
  };
};
